import { render, staticRenderFns } from "./Pagina.vue?vue&type=template&id=19a3aee4&scoped=true&lang=pug&"
import script from "./Pagina.vue?vue&type=script&lang=js&"
export * from "./Pagina.vue?vue&type=script&lang=js&"
import style0 from "./Pagina.styl?vue&type=style&index=0&id=19a3aee4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a3aee4",
  null
  
)

export default component.exports